export enum ERequestListPageTab {
  Requests = 'requests',
  Supplies = 'supplies',
}

export enum ERequestStatus {
  Created = 'created',
  Processing = 'processing',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
}

export enum ERequestStatusLabel {
  created = 'На согласовании',
  processing = 'Согласован',
  cancelled = 'Отменен',
  delivered = 'Завершен',
}

export enum ERequestDetailsTab {
  General = 'general',
  Updates = 'updates',
}

export enum ERequestGoodsInfoMenuKey {
  General = 'general',
}

export enum ERequestSupplyGroupKey {
  Created = 'created',
  Pending = 'pending',
  Processing = 'processing',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
}

export enum ERequestSupplyGroupType {
  Date = 'date',
  Data = 'data',
}
